import {
    TOGGLE_RECEIVER
} from '../actions';

const initialState = {
    selectedReceivers: []
};

function toggleReceiver(state, action){
    let receiver = action.payload.receiver;
    let checked = action.payload.checked;
    if(checked){
        if(state.selectedReceivers.indexOf(receiver) === -1){
            state.selectedReceivers.push(receiver);
        }
    } else {
        if(state.selectedReceivers.indexOf(receiver) !== -1){
            state.selectedReceivers.splice(state.selectedReceivers.indexOf(receiver), 1);
        }
    }
    state.selectedReceivers = state.selectedReceivers.slice();
    return {...state};
}


export default function NotificationsReducer(state = initialState, action) {
    switch (action.type) {
        case TOGGLE_RECEIVER:
            return toggleReceiver(state, action);
        default:
            return state;
    }
}




// WEBPACK FOOTER //
// ./src/reducers/NotificationsReducer.js